var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 2,
    fill: "#183433"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13337_80471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 19C24.5523 19 25 19.4477 25 20V24C25 25.1046 24.1046 26 23 26H9C7.89543 26 7 25.1046 7 24V20C7 19.4477 7.44772 19 8 19C8.55228 19 9 19.4477 9 20V24H23V20C23 19.4477 23.4477 19 24 19ZM16 6C16.5523 6 17 6.44772 17 7V17.2426L19.5355 14.7071C19.9261 14.3165 20.5592 14.3165 20.9497 14.7071C21.3403 15.0976 21.3403 15.7308 20.9497 16.1213L16.8839 20.1871C16.3957 20.6753 15.6043 20.6753 15.1161 20.1871L11.0503 16.1213C10.6597 15.7308 10.6597 15.0976 11.0503 14.7071C11.4408 14.3165 12.0739 14.3165 12.4645 14.7071L15 17.2426V7C15 6.44772 15.4477 6 16 6Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13337_80471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPdf);
export default __webpack_public_path__ + "static/media/downloadPdf.2400f1ac69e6d5d5c9183e8568f2714d.svg";
export { ForwardRef as ReactComponent };